

















































































































import { Vue, Component } from "vue-property-decorator";
import DateRangePicker from "@/components/Forms/DateRangePicker.vue";
import Autocomplete from "@/components/Forms/Autocomplete.vue";
import ComboBox from "@/components/Forms/ComboBox.vue";
import requestStore from "@/store/requestStore";
import format from "date-fns/format";
import { DATE_PICKER_FORMAT } from "@/Constants";
import { SuburbAndStreetsModel } from "@/api/Shared";
import { Observer } from "mobx-vue";
import { IObservableArray } from "mobx";
import { addDataCyToComboBox } from "@/UITestHelper/UITestHelper";

@Observer
@Component({ components: { DateRangePicker, Autocomplete, ComboBox } })
export default class RequestFilters extends Vue {
  requestStore = requestStore;

  get today() {
    return format(new Date(), DATE_PICKER_FORMAT);
  }
  searchSuburbs(query: string) {
    if (!query) return [];

    const matches = requestStore.suburbs.filter(s => s?.suburbName.toUpperCase().indexOf(query.toUpperCase()) >= 0);

    return matches;
  }

  searchStreets(query: string) {
    if (!query) return [];
    const getStreetsFromSuburbs = (sourceSuburbs: SuburbAndStreetsModel[]): string[] => {
      const allStreets = sourceSuburbs.map(s => (s.streetNames as IObservableArray<string>).toJS()).reduce((a, b) => a.concat(b), []);
      const distinctStreets = new Set(allStreets);
      return Array.from(distinctStreets).sort();
    };

    const streetNames =
      !this.requestStore.filters.suburbs || this.requestStore.filters.suburbs.length === 0
        ? getStreetsFromSuburbs(requestStore.suburbs)
        : getStreetsFromSuburbs(requestStore.filters.suburbs);

    const matches = streetNames.filter(s => s && s.toUpperCase().indexOf(query.toUpperCase()) >= 0);
    return matches;
  }

  clearCache() {
    const myAuto1 = this.$refs.mySuburbs as Autocomplete;
    const myAuto2 = this.$refs.myStreets as Autocomplete;
    myAuto1.clearCache();
    myAuto2.clearCache();
  }

  mounted() {
    addDataCyToComboBox();
  }
}
